const InfoItem = ({ label, value, className = "" }) => (
  <div
    className={`flex flex-col border-b border-[#a2a1a833] gap-1 py-2 ${className}`}
  >
    <strong className="text-[#A2A1A8] text-sm font-sf-light">{label}</strong>
    <span className="text-[#16151C]">{value}</span>
  </div>
);
export default InfoItem;
